module.exports = __webpack_public_path__ + "img/dollar-outline-grey.52afb267.svg";